import gql from 'graphql-tag';

const buildingQueries = {

    findBuildings: gql`
        query FindBuildings($name: String, $id: Int) {
          findBuildings(count: 10, name: $name, id: $id) {
            data {
              id
              name
            }
          }
        }
    `,

    findParentBuildings: gql`
        query FindBuildings($name: String, $id: Int) {
          findBuildings(
            count: 9999,
            id: $id,            # whereNot
            name: $name,        # where
            parent_id : null,
            orderBy: [{ field: "code", order: ASC} , { field: "name", order: ASC }]
        ) {
            data {
              id
              name
              street
              number
              zip
              city
              warranty_period_end
              children {
                  id
                  name
                  street
                  number
                  zip
                  city
              }
            }
          }
        }
    `,

    allBuildings: gql`
        query Buildings {
            buildings(count: 9999, orderBy: [{ field: "parent_id", order: ASC}]) {
                data {
                    id
                    name
                    code
                    street
                    number
                    zip
                    city
                }
            }
        }
    `,

    getSubordinates: gql`
        query Buildings($parent_id: Int!) {
            buildings(
                count      : 9999 # paginator
                parent_id : $parent_id    # where
                orderBy    : [
                    { field: "name", order: ASC },
                ]
            ){
                data {
                    id
                    name
                    code
                    street
                    number
                    zip
                    city
                    contracts {
                        id
                    }
                    builder {
                        id
                        is_company
                        company_name
                    }
                    projects{
                        project {
                            id
                            name
                            number_internal
                            reminder
                            status {
                                name
                                prio
                                color
                                closed
                            }
                            contacts {
                                contact{
                                    id
                                    company_name
                                }
                            }
                        }
                    }
                }
            }
        }
    `,

};

export default buildingQueries;
